import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { CSRFTOKEN } from '../redux/constant/constants';
import Popup from "reactjs-popup";
import Dropzone from "react-dropzone";
import { updateNewPlan, deletePanelumImage, uploadFilesToServerPanelum } from '../serverRequests/requests';
import { nextStep, set360ToolsAction, ifloorplanStateAdd, panelumLib, changePannellumKey, clearIfloorState, changeLevel, set360LibSort, changeImageKey, updateSingle360Action } from '../redux/actions/actions';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';

const PanoramaLibrary = (props) => {
    const ifloorplanObj = props.ifloorplanNowState; //last ifloor plan obj
    const panoramaLenght = ifloorplanObj.level[props.levelNowId].panelum.length;
    const [images, setImages] = useState([]);
    const [selectedPoint, setSelectedPoint] = useState('');
    const [selectedImage, setSelectedImage] = useState("");
    const [blockHoverId , setBlockHoverId] = useState('');
    const [blockText, setBlockText] = useState('');

    const [replaceId, setReplaceId] = useState('');
    const [replacePopup, setReplacePopup] = useState(false);
    const [pannellumLib, setPannellumLib] = useState([])
    const [coverPopup, setCoverPopup] = useState(false);
    const [coverPopupError1, setCoverPopupError1] = useState(false);
    const [coverPopupError2, setCoverPopupError2] = useState(false);

    const [deletePopup, setDeletePopup] = useState(false);
    const [delete360Id, setDelete360Id] = useState();

    const [libImage, setLibImage] = useState([]);
    const [coverImg, setCoverImg] = useState("");

    const [updateImageId, setUpdateImageId] = useState(null);
    const [updateImagePopup, setUpdateImagePopup] = useState(false);

    



    useEffect(() => {
        initSort();
    }, [props.panelum_lib]);

    const initSort = () => {
        let newImageSort = JSON.parse(JSON.stringify(props.sort_360_lib.length > 0 ? props.sort_360_lib : props.panelum_lib));
        for (let i = 0; i < newImageSort.length; i++){
            newImageSort[i].selected = false;
        }
            
        for (let i = 0; i < props.panelum_lib.length; ++i){
            const res = newImageSort.find(items => items.id === props.panelum_lib[i].id);
            if (res === undefined){
                newImageSort.push(props.panelum_lib[i]);
            }
            else newImageSort[newImageSort.indexOf(res)] = props.panelum_lib[i];
        }
        setPannellumLib(newImageSort);
        props.set360LibSort(newImageSort);
    }

    const addImage = () => {
        props.nextStep("360 library upload", "360 library");
    };

    const deselectAll = () => {
        const lib = [...pannellumLib];
        for(let i = 0; i < lib.length; i++){
            lib[i].selected = false;
        }
        setPannellumLib(lib);
    }

    // const Cover = () => {
    //     //method for change first image
    //     const coverArr = [];
    //     const lib = [...libImage];
    //     for(let i = 0; i < lib.length; i++){ //searched selected image and push to array
    //         if(lib[i].selected){
    //             coverArr.push(lib[i]);
    //         }
    //     }
    //     if(coverArr.length === 1){ //valid array if lenght == 1 -> set image
    //         setCoverImg(coverArr[0].image);
    //         setCoverPopup(false);
    //     } else if(coverArr.length >= 1){ //if lenght > 1 error
    //         setCoverPopupError1(true);
    //     } else {                         // if lenght = 0 error
    //         setCoverPopupError2(true);
    //     }
    // }

    const deleteAll = () => {
        props.changePannellumKey(-1);
        //delete all images and delete all cam position releted him
        let form_data = {
            ifloorplan_id: ifloorplanObj.id,
            level_id: ifloorplanObj.level[props.levelNowId].id,
            many: [],
        }
        const lib = [...pannellumLib];
        for(let i = 0; i < lib.length; i++){ //mapping images to delete
            lib[i].deleted = true;
        }
        for(let i = 0; i < lib.length; i++){
            if(lib[i].deleted){
                form_data.many.push(lib[i].id);
            }
        }
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        for(let i = 0; i < newState.level.length; i++){ //delete all images obj
            newState.level[i].panelum = [];
        }
        updateNewPlan(newState)
            //update ifloor plan object mai state
            .then(data=>{
                props.setAnimation(animationSaved=>animationSaved+1);
                props.changeLevel(0);
                props.changePannellumKey(-1);
                props.ifloorplanStateAdd(data[0]); //update state ifloorplan
            });
            deletePanelumImage(form_data)
            //delete all images and upload new images
            .then(res=> {
                props.set360LibSort([]);
                props.panelumLib([]);
                props.setAnimation(animationSaved=>animationSaved+1);
                props.nextStep("360 library upload", "360 library");
            });
    }
    
    const useSelected360s = () => {
        const checked360s = [];
        for(let i = 0; i < pannellumLib.length; i++){ //find selected image and add to array
            if(pannellumLib[i].selected){
                checked360s.push(pannellumLib[i]);
            }
        }
        // -------------------------------------------------------------------------------------
        //algorithm for sort images in library with support deleted, change index and create new objects
        let oldImagesState = JSON.parse(JSON.stringify(ifloorplanObj.level[props.levelNowId].panelum));
        for(let i = 0; i < checked360s.length; i++){
            let found = false;
            for(let j = 0; j < oldImagesState.length; j++){
                if(checked360s[i].id === oldImagesState[j].id_lib_img){
                    oldImagesState[j].img = checked360s[i].image;
                    found = true;
                }
            }
            if(!found){ //this part create new objects if they exist
                const new360Object = {
                    img: checked360s[i].image,
                    id_lib_img: checked360s[i].id,
                }
                oldImagesState.push(new360Object);
            }
            //if array chekedImages not have items which are in array oldImagesState then they delete
        }
        //------------------------------------------end-------------------
        return oldImagesState;
    }

    const toggleChecked = (id) => {
        //maping images like "selected"
        const lib = [...pannellumLib];
        for(let i = 0; i < lib.length; i++){
            if(lib[i].id == id){
                lib[i].selected = !lib[i].selected;
                setPannellumLib(lib);
                break;
            }
        }
    }

    const SelectAll = (isTrue) => {
        const lib = [...pannellumLib];
        for (let i=0; i<lib.length; i++){
            lib[i].selected = isTrue;
        }
        setPannellumLib(lib);
    }

    const updateImages = (dataArray) => {
        props.pannellumLib(dataArray);  //add to library
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        let oldImages = newState.level[props.levelNowId].panelum;
        let newStateImages = [];
        for(let i = 0; i < dataArray.length; i++){
            for(let j  = 0; j < oldImages.length; j++){
                if(dataArray[i].id === oldImages[j].id_lib_img){
                    oldImages[j].img = dataArray[i].img;
                    newStateImages.push(oldImages[j]);
                }
            }
        }
        newState.panelum = newStateImages;
    }

    const Save = () => {
        const new360State = useSelected360s();
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        newState.level[props.levelNowId].panelum = new360State;
        let newIndex = 0;
        for(let i = 0; i < pannellumLib.length; i++){
            for(let j = 0; j < newState.level.length; j++){
                let result = newState.level[j].panelum.find((item, index) => {
                    if(item.id_lib_img === pannellumLib[i].id){
                        return true;
                    }
                });
                if(result !== undefined){
                    // result.index = newIndex;
                    result.img = pannellumLib[i].image;
                    newIndex++;
                }
            }
        }

        updateNewPlan(newState)
            //update ifloor plan object main state
            .then(data => {
                props.setAnimation(animationSaved=>animationSaved+1);
                props.ifloorplanStateAdd(data[0]); //update state ifloorplan
                if(props.prev_step === "new level"){
                    props.nextStep("scale layout", "new level");
                    return;
                }
                if(data[0].level[props.levelNowId].panelum.length !== 0){
                    props.changePannellumKey(0);
                    props.changeImageKey(-1);
                    props.nextStep("cams position", "_");
                    return;
                }
                else if (data[0].level[props.levelNowId].images.length !== 0) {
                    props.changeImageKey(0);
                    props.changePannellumKey(-1);
                    props.nextStep("cams position", "_")
                    return;
                }
                props.nextStep("scale layout", "_");
            });
        props.panelumLib(pannellumLib);
    }

    const simpleDelete = () => {
        //delete one image and delete cam position releted him
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        for(let i = 0; i < newState.level.length; i++){
            for(let j = 0; j < newState.level[i].panelum.length; j++){
                if(newState.level[i].panelum[j].id_lib_img === delete360Id){
                    newState.level[i].panelum.splice(j, 1);
                }
            }
        }
        const lib = [...pannellumLib];
        const data = {
            ifloorplan_id: ifloorplanObj.id,
            simple: delete360Id,
        }
        deletePanelumImage(data)
            .then((data)=>{
                props.set360LibSort(data);
                props.panelumLib(data);
                setDeletePopup(false);
                setDelete360Id('');
                updateNewPlan(newState)
                    .then((data)=>{
                        props.setAnimation(animationSaved=>animationSaved+1);
                        props.ifloorplanStateAdd(data[0]);
                    })
            })
    }

    const handleSingleUploadImage = () => {
        props.updateSingle360Action(updateImageId);
        props.nextStep("single 360", "update single 360");
    }

    //===================================================================
    const SortableItem = SortableElement(({value}) => {
        let in_this_level = false;
        for(let i = 0; i < ifloorplanObj.level[props.levelNowId].panelum.length; i++){
            if(ifloorplanObj.level[props.levelNowId].panelum[i].id_lib_img == value.id){
                in_this_level = true;
            }
        }

        return <div className="imageItem_sub">
            { value.selected ? <div className="checked"><i className="fa fa-check" aria-hidden="true"></i></div> : ''}
            <div className="image"  onClick={()=>{toggleChecked(value.id)}}>
                <img src={value.image} alt=""/>
            </div>
            {in_this_level ? <div className="now_level"><p>In use on this level</p></div> : ""}
            <div className="options">
                <img title='Replace this image' style={{height: '13px', cursor: 'pointer',marginRight: '6px'}} rel="shortcut icon" type="image/png" src="/static/public/img/library-replace-icon.svg" onClick={()=>{setUpdateImageId(value.id);setUpdateImagePopup(true)}}/>
                {/* <i className="fa fa-plus" onClick={()=>{setUpdateImageId(value.id);setUpdateImagePopup(true)}} aria-hidden="true">
                    <span className="toolTip">Replace this image</span>
                </i> */}
                <img title='Delete this image' style={{height: '13px', cursor: 'pointer'}} rel="shortcut icon" type="image/png" src="/static/public/img/library-delete-icon.svg" onClick={()=>{setDelete360Id(value.id);setDeletePopup(true);}}/>
                {/* <i className="fa fa-minus" onClick={()=>{setDelete360Id(value.id);setDeletePopup(true);}} aria-hidden="true">
                    <span className="toolTip">Delete this image</span>
                </i> */}
            </div>
        </div>
    }
);

    const SortableList = SortableContainer(({items}) => {
        return (
            <div className="plansLib">

                {items.map((value, index) => (
                    <SortableItem key={`item-${value.id}`} index={index} value={value} />
                ))}
            </div>
        );
    });
    //=============================================================================

    useEffect(()=>{
        // start after render component
        const items_img = document.getElementsByClassName('image'); // disable standart drag callback
        for(let i = 0; i < items_img.length; i++){
            items_img[i].ondragstart = function() {
                return false;
            };
        }
        if(props.setShowTools)
            props.setShowTools(true);
    }, []);

    useEffect(()=>{
        if (libImage.length > 0) props.setImageLibSort(libImage);
    }, [libImage])


    const onSortEnd = ({oldIndex, newIndex}) => {
        setLibImage(arrayMove(libImage, oldIndex, newIndex));
    }

    return (
        <div className="planLibrary">
            <div className="btnGroup">
                <div className="btn_lib_left">
                    <div><h2>360 Image Library</h2></div>
                    <div>
                        <div className="addImageBlock">
                            <button onClick={addImage}>Add 360 Images <i className="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                    </div>
                </div>
                <div className="btn_lib_right">
                    <div className="btn_link_lib">
                        <div>
                            <button onClick={()=>setReplacePopup(true)}>Replace all 360 images</button>
                        </div>
                        <div>
                            <button onClick={()=>{
                                if(props.prev_step == "exist images"){
                                    return 1;
                                }
                                if (props.prev_step === "first") {
                                    props.nextStep("scale layout", "_");
                                }
                                else {
                                    props.nextStep("cams position", "_");
                                }
                            }}>Cancel</button>
                        </div>
                    </div>
                    <div className="btn_orange_lib">
                        {/*<div>*/}
                        {/*    <button onClick={useSelectedImages}>Use selected images</button>*/}
                        {/*</div>*/}
                        <div>
                            <button onClick={Save}>Use selected images and Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="titleBlock">
                <div className="midBlockTitle">
                    <div><h2>Select images for this level</h2></div>
                    <div className="selectOption">
                        <button 
                            style = {{
                                borderRight: "1px solid #908f8f",
                                height: "40px"
                            }}
                            onClick={() => {SelectAll(true)}}>
                            Select All
                        </button>
                        <button
                            onClick={() => {SelectAll(false)}}>
                            Select None
                        </button>
                    </div>
                    
                </div>

            </div>
            <SortableList axis={"xy"} distance={5} items={pannellumLib} onSortEnd={onSortEnd} />

            <Popup
                open={deletePopup}
                closeOnDocumentClick
                onClose={()=> {
                    setDeletePopup(false);
                }}
            >
                <div className="modal">
                    <p className="title_modal">Delete this image?</p>
                    <p className="description_modal">All markers associated with this image will be removed.</p>
                    <div className="btnGroup">
                        <button onClick={()=>setDeletePopup(false)}>Cancel</button>
                        <button onClick={simpleDelete}>OK</button>
                    </div>
                </div>
            </Popup>


            <Popup
                open={coverPopupError2}
                closeOnDocumentClick
                onClose={()=> {
                    setCoverPopupError2(false);
                    setCoverPopup(false);
                }}
            >
                <div className="modal">
                    <p className="title_modal">You must select one image</p><br/>

                </div>
            </Popup>

            <Popup
                open={coverPopupError1}
                closeOnDocumentClick
                onClose={()=> setCoverPopupError1(false)}
            >
                <div className="modal">
                    <p className="title_modal">Deselect all images and select 1 image for the splash screen.</p><br/>
                    <div className="btnGroup">
                        <button onClick={()=> {
                            setCoverPopupError1(false);
                            setCoverPopupError2(false);
                            setCoverPopup(false);
                        }}>Cancel</button>
                        <button onClick={()=> {
                            setCoverPopupError1(false);
                            setCoverPopupError2(false);
                            setCoverPopup(false);
                            deselectAll();
                        }
                        }>Deselect all</button>
                    </div>
                </div>
            </Popup>

            <Popup
                open={updateImagePopup}
                closeOnDocumentClick
                onClose={()=> setUpdateImagePopup(false)}
            >
                <div className="modal">
                    <h2 className="title_modal" style={{color: '#737373',fontWeight: 700,
                    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif", marginBottom: "30px"}}>Update this image?</h2>
                    <p className="description_modal">The Marker for this image will remain in position and will use the updated image.</p>
                    <div className="btnGroup">
                        <button onClick={()=> setUpdateImagePopup(false)}>Cancel</button>
                        <button onClick={()=> handleSingleUploadImage()}>OK</button>
                    </div>
                </div>
            </Popup>


            <Popup
                open={replacePopup}
                closeOnDocumentClick
                onClose={()=> setReplacePopup(false)}
            >
                <div className="modal">
                    <p className="title_modal">Are you sure you want to delete all images?</p><br/>
                    <p className="description_modal">This will delete all images and take you to the image uploader where you can upload new images.</p>
                    <p className="description_modal">You will have to place each marker again.</p>
                    <div className="btnGroup">
                        <button onClick={()=> setReplacePopup(false)}>Cancel</button>
                        <button onClick={()=> deleteAll()}>Delete all and re-upload</button>
                    </div>
                </div>
            </Popup>


            <Popup
                open={coverPopup}
                closeOnDocumentClick
                onClose={()=> setCoverPopup(false)}
            >
                <div className="modal">
                    <p className="title_modal">Use selected image for the splash screen?</p><br/>
                    <div className="btnGroup">
                        <button onClick={()=> setCoverPopup(false)}>Cancel</button>
                        <button onClick={()=> {
                            Cover();
                            setCoverPopup(false);
                        }}>OK</button>
                    </div>
                </div>
            </Popup>

        </div>
    )
}

//     const simpleDelete = (id) => {
//          const data = {
//             simple: id,
//             ifloorplan_id: ifloorplanObj.id
//         }
//         deletePanelumImage(data)
//             .then((res)=>{
//                 props.panelumLib(res); //update library
//                 const newPanelumArr = [];
//                 let newState = JSON.parse(JSON.stringify(ifloorplanObj));
//                 //if removed image in panelum object -> delete panelum obj
//                 for(let i = 0; i < newState.level[props.levelNowId].panelum.length; i++){
//                     const instance_id = newState.level[props.levelNowId].panelum[i].id_lib_img;
//                     if(instance_id != id){
//                         newPanelumArr.push(newState.level[props.levelNowId].panelum[i]);
//                     }
//                 }
//                 newState.level[props.levelNowId].panelum = newPanelumArr;
//                 updateNewPlan(newState)
//                     .then((data)=>{
//                         props.setAnimation(animationSaved=>animationSaved+1);
//                         props.ifloorplanStateAdd(data[0]);
//                     })
//             })
//     }

//     const replaceOne = (files) => {
//         setReplacePopup(false);
//         const config = {
//             headers: {
//                 "X-CSRFToken": CSRFTOKEN,
//                 'content-type': 'multipart/form-data'
//             }
//         }
//         let form_data = new FormData();
//         form_data.append('ifloorplan_id', ifloorplanObj.id);
//         form_data.append('image', files[0], files[0].name);
//         form_data.append('id', replaceId);
//         uploadFilesToServerPanelum("/api/panelum/", form_data, config)
//             .then(res => {
//                 props.panelumLib(res.data);
//                 let newState = JSON.parse(JSON.stringify(ifloorplanObj));
//                 //update image
//                 for(let i = 0; i < newState.level[props.levelNowId].panelum.length; i++){
//                     const instance_id = newState.level[props.levelNowId].panelum[i].id_lib_img;
//                     for(let j = 0; j < res.data.length; j++){
//                         if(instance_id === res.data[j].id){
//                             newState.level[props.levelNowId].panelum[i].img = res.data[j].image;
//                         }
//                     }
//                 }
//                 updateNewPlan(newState)
//                     .then((data)=>{
//                         props.setAnimation(animationSaved=>animationSaved+1);
//                         props.ifloorplanStateAdd(data[0]);
//                     })
//             })
//     }

//     const initImage = () => {
//         setImages([]);
//         const img = [];
//         for(let i = 0; i < props.panelum_lib.length; i++){
//             let img_active = props.panelum_lib[i].image;
//             img.push(<div className="pan_image_wrap active" key={i} >
//                 {i === selectedPoint ? <div className="checked"><i className="fa fa-check" aria-hidden="true"></i></div> : ''}
//                 <img src={img_active} alt="" onClick={()=>{
//                 setSelectedImage(img_active);
//                 setSelectedId(props.panelum_lib[i].id);
//                 setSelectedPoint(i);
//             }}/>
//                 {blockHoverId === i ? <div className="hover__lib_text">{blockText}</div> : ''}
//                 <div className="options">
//                     <div><i
//                         onClick={()=>{
//                             setReplaceId(props.panelum_lib[i].id);
//                             setReplacePopup(true);
//                         }}
//                         onMouseOut={()=>{
//                             setBlockHoverId('');
//                             setBlockText("");
//                         }}
//                         onMouseEnter={()=>{
//                             setBlockHoverId(i);
//                             setBlockText("Replace this image");
//                         }}
//                         className="fa fa-plus" aria-hidden="true"></i></div>
//                     <div><i
//                         onClick={()=>{
//                             simpleDelete(props.panelum_lib[i].id);
//                         }}
//                         onMouseOut={()=>{
//                             setBlockHoverId('');
//                             setBlockText("");
//                         }}
//                         onMouseEnter={()=>{
//                             setBlockHoverId(i);
//                             setBlockText("Remove this image");
//                         }}
//                         className="fa fa-minus" aria-hidden="true"></i></div>
//                 </div>
//             </div>)

//         }
//         setImages(img);
//     }

//     useEffect(()=>{
//         initImage();
//         if(props.setShowTools)
//             props.setShowTools(true);
//     }, []);

//     useEffect(()=>{
//         initImage();
//     }, [selectedPoint, blockHoverId, props.panelum_lib]);


//     const Save = () => {
//         let newState = JSON.parse(JSON.stringify(ifloorplanObj));
//         newState.level[props.levelNowId].panelum[panoramaLenght - 1].img = selectedImage;
//         newState.level[props.levelNowId].panelum[panoramaLenght - 1].id_lib_img = setSelectedId;
//         updateNewPlan(newState)
//             .then((data)=>{
//                 props.setAnimation(animationSaved=>animationSaved+1);
//                 props.ifloorplanStateAdd(data[0]);
//                 props.nextStep("panorama", "_");
//                 props.set360ToolsAction("markers");
//             })
//     }

//     const replaceAll = () => {
//         const id_to_delete = [];
//         for(let i = 0; i < props.panelum_lib.length; i++){
//             id_to_delete.push(props.panelum_lib[i].id);
//         }
//         const data = {
//             many: id_to_delete,
//             ifloorplan_id: ifloorplanObj.id
//         }
//         deletePanelumImage(data)
//             .then((res)=>{
//                 props.panelumLib(res);
//                 let newState = JSON.parse(JSON.stringify(ifloorplanObj));
//                 newState.level[props.levelNowId].panelum = [];
//                 updateNewPlan(newState)
//                     .then((data)=>{
//                         props.setAnimation(animationSaved=>animationSaved+1);
//                         props.ifloorplanStateAdd(data[0]);
//                         props.nextStep("360 library upload", "_");
//                     })
//             })
//     }

//     return (
//         <div className="panorama_lib">
//             <div className="panorama_tools_lib">
//                 <div className="rep_add_tools_lib">
//                     <h3>360 Image Library</h3>
//                     <button className="add360" onClick={()=>{
//                         props.nextStep("panorama single upload file", "_");
//                     }}>Add 360 Image +</button>
//                     <button className="replace360all"
//                         onClick={replaceAll}
//                     >Replace all images</button>
//                 </div>
//                 <div className="can_save_tools_lib">
//                     <button className="cancel" onClick={()=>{
//                         props.nextStep("panorama", "_");
//                         props.set360ToolsAction("choose");
//                     }}>Cancel</button>
//                     <button className="selected" onClick={Save}>Use selected</button>
//                 </div>
//             </div>
//             <div className="panorama_title_wrap">
//                 <div className="description_pan">
//                     <p>Replace Image</p>
//                     <p>Add image</p>
//                     <p>Remove image</p>
//                     <p>Replace all image</p>
//                 </div>
//                 <div className="main_pan_title">
//                     <h3>Click an image to select</h3>
//                 </div>
//             </div>
//             <div className="panorama_img_wrap_lib">
//                 {images}
//             </div>

//             <Popup
//                 open={replasePopup}
//                 closeOnDocumentClick
//                 onClose={()=> {
//                     setReplacePopup(false);
//                 }}
//             >
//                 <div className="modal">
//                     <Dropzone onDrop={replaceOne}>
//                         {({ getRootProps, getInputProps }) => (
//                             <div {...getRootProps({ className: "dropzone" })}>
//                                 <h3>Drop a single image file here...</h3><br/>
//                                 <h3>Or</h3><br/>
//                                 <input {...getInputProps()} />
//                                 <button>Choose file</button><br/>
//                                 <p>Single file upload</p>
//                             </div>

//                         )}
//                     </Dropzone>
//                     <button onClick={()=>{
//                                     setReplacePopup(false);
//                                 }}>Cancel</button>
//                 </div>
//             </Popup>

//         </div>
//     )
// }

const putState = (state) => {
    return {
        step: state.step,
        prev_step: state.prev_step,
        ifloorplanNowState: state.ifloorplanNowState,
        levelNowId: state.levelNowId,
        panelum_lib: state.panelum_lib,
        sort_360_lib: state.sort_360_lib,
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        panelumLib: (items) => dispatch(panelumLib(items)),
        set360ToolsAction: (value) => dispatch(set360ToolsAction(value)),
        clearIfloorState: () => dispatch(clearIfloorState()),
        changePannellumKey: (key) => dispatch(changePannellumKey(key)),
        changeLevel: (level) => dispatch(changeLevel(level)),
        updateSingle360Action: (id) => dispatch(updateSingle360Action(id)),
        set360LibSort: (array) => dispatch(set360LibSort(array)),
        changeImageKey: (key) => dispatch(changeImageKey(key)),
        deletePanelumImage: (data) => dispatch(deletePanelumImage(data))
    }
}

export default connect(putState, putActions) (PanoramaLibrary);

